import Vue from 'vue'
import Router from 'vue-router'

import Login from 'login/Login'
import Agreement from 'login/Agreement'
import Index from 'index/Index'
import VoucherQrCode from 'voucher/VoucherQrCode'
import VoucherChooseType from 'voucher/VoucherChooseType'
import VoucherAdd from 'voucher/VoucherAdd'
import VoucherRegister from 'voucher/VoucherRegister'
import VoucherRegisterPhoto from 'voucher/VoucherRegisterPhoto'
import VoucherDetail from 'voucher/VoucherDetail'
import Pay from 'pay/Pay'
import PaySuccess from 'pay/PaySuccess'
import RegDetail from 'myregister/RegDetail'
import DepartDoctor from 'register/DepartDoctor'
import DateDoctorSchedule from 'register/DateDoctorSchedule'
import DateTimeSchedule from 'register/DateTimeSchedule'
import TimeSchedule from 'register/TimeSchedule'
import RegistConfirm from 'register/RegistConfirm'
import Mypay from 'mypay/Mypay'
import MypayDetail from 'mypay/MypayDetail'
import SelfPay from 'pay/SelfPay'
import MyRegister from 'myregister/MyRegister'
import ClinicUnpayList from 'clinic/ClinicUnpayList'
import ClinicUnpayDetail from 'clinic/ClinicUnpayDetail'
import MyReport from 'myreport/MyReport'
import LabDetail from 'myreport/LabDetail'
import ExamDetail from 'myreport/ExamDetail'
import HosInfo from 'hospitalinfo/HosInfo'
import Personal from 'profile/Personal'
import Profile from 'profile/Profile'
import ModifyPhone from 'profile/ModifyPhone'
import ConfirmPhone from 'profile/ConfirmPhone'
import HospitalSelect from 'hospitalSelect/hospitalSelect'
import AreaSelect from 'areaSelect/AreaSelect'
import DoctInfoList from 'doctinfo/DoctInfoList'
import DoctInfo from 'doctinfo/DoctInfo'
import BedsInfo from 'beds/BedsInfo'
import VoucherSelect from 'healthRecord/VoucherSelect'
import RecordSelect from 'healthRecord/RecordSelect'
import Character from 'healthRecord/Character'
import PhysicalExam from 'healthRecord/PhysicalExam'
import PhysicalExamDetail from 'healthRecord/PhysicalExamDetail'
import VisitRecord from 'healthRecord/VisitRecord'
import VisitRecordDetail from 'healthRecord/VisitRecordDetail'
import Developing from 'developing/developing'
import Maintaing from 'maintaing/maintaing'
import InpatientRecharge from 'inpatientRecharge/InpatientRecharge'
import MyRecharge from 'inpatientRecharge/MyRecharge'
import GoRecharge from 'inpatientRecharge/GoRecharge'
import BookingResult from 'pay/BookingResult'
import UnionPay from 'pay/UnionPay'
import GetLocation from "map/GetLocation";
import OutMap from 'map/OutMap'
import InMap from 'map/InMap'
import Survey from 'survey/Survey'
import SurveyList from 'survey/SurveyList'
import SurveyDetail from 'survey/SurveyDetail'
import FamilyDoctor from 'familyDoctor/FamilyDoctor'
import Signed from 'familyDoctor/Signed'
import NoSigned from 'familyDoctor/NoSigned'
import Review from 'familyDoctor/Review'
import MyPrescription from 'elcPrescription/MyPrescription'
import PrescriptionDetail from 'elcPrescription/PrescriptionDetail'
import WaitDoctor from  'waitDoctor/WaitDoctor'
import InpatientRegister from 'inpatientRegister/InpatientRegister'
import InpatientDetails from 'inpatientRegister/InpatientDetails'
import FamilyArgeeMent from 'familyDoctor/FamilyArgeeMent'
import HospitalPage from 'hospitalPage/HospitalPage'
import HealthySichuanRegister from 'hospitalPage/HealthySichuanRegister'
import HealthySichuanMyRegister from 'hospitalPage/HealthySichuanMyRegister'
import HospitalCostList from 'hospitalCostList/inpatientCostList'
import HospitalCostListDetail from 'hospitalCostList/HospitalCostListDetail'
import registeredPrompt from 'registeredPrompt/registeredPrompt'
import residentHealthRecord from 'residentHealthRecord/VoucherSelect'
import residentHealthRecordCode from 'residentHealthRecord/sendVerifyCode'
import internetHospital from 'internetHospital/internetHospital'
import littleAssistant from 'littleAssistant/littleAssistant'
Vue.use(Router)

var routes = [
    {
        path: '/login',
        component: Login,
        meta: {
            title: '账号登录'
        }
    }, {
        path: '/',
        name: 'index',
        component: Index,
        meta: {
            title: '首页'
        }
    }, {
        path: '/voucherQrCode',
        component: VoucherQrCode,
        meta: {
            title: '我的二维码'
        }
    }, {
        path: '/voucherChooseType',
        component: VoucherChooseType,
        meta: {
            title: '办卡方式选择'
        }
    }, {
        path: '/voucheradd',
        component: VoucherAdd,
        meta: {
            title: '绑定就诊凭证'
        }
    }, {
        path: '/voucherRegister',
        component: VoucherRegister,
        meta: {
            title: '申请电子健康卡'
        }
    }, {
        path: '/voucherRegisterPhoto',
        component: VoucherRegisterPhoto,
        meta: {
            title: '证件照上传'
        }
    }, {
        path: '/voucherDetail',
        name: 'voucherDetail',
        component: VoucherDetail,
        meta: {
            title: '就诊凭证详情'
        }
    }, {
        path: '/pay',
        name: 'pay',
        component: Pay,
        meta: {
            title: '选择支付方式'
        }
    }, {
        path: '/paysuccess',
        name: 'paySuccess',
        component: PaySuccess,
        meta: {
            title: '支付状态'
        }
    }, {
        path: '/selfpay',
        name: 'selfpay',
        component: SelfPay,
        meta: {
            title: '请扫码支付'
        }
    }, {
        path: '/regdetail',
        name: "regDetail",
        component: RegDetail,
        meta: {
            title: '订单详情'
        }
    }, {
        path: '/departDoctor',
        name: "departDoctor",
        component: DepartDoctor,
        meta: {
            title: '选择科室或医生'
        }
    }, {
        path: '/dateDoctorSchedule',
        name: "dateDoctorSchedule",
        component: DateDoctorSchedule,
        meta: {
            title: ''
        }
    }, {
        path: "/dateTimeSchedule",
        name: "dateTimeSchedule",
        component: DateTimeSchedule,
        meta: {
            title: '选择时间段'
        }
    }, {
        path: "/timeSchedule",
        name: "timeSchedule",
        component: TimeSchedule,
        meta: {
            title: '号源详情'
        }
    }, {
        path: "/registConfirm",
        name: "registConfirm",
        component: RegistConfirm,
        meta: {
            title: '确认挂号信息'
        }
    }, {
        path: '/mypay',
        name: 'mypay',
        component: Mypay,
        meta: {
            title: '我的缴费'
        }
    }, {
        path: '/mypayDetail',
        name: 'mypayDetail',
        component: MypayDetail,
        meta: {
            title: '缴费明细'
        }
    }, {
        path: '/myregister',
        name: 'myregister',
        component: MyRegister,
        meta: {
            title: '我的挂号'
        }
    }, {
        path: '/clinicUnpayList',
        name: 'clinicUnpayList',
        component: ClinicUnpayList,
        meta: {
            title: '门诊缴费'
        }
    }, {
        path: '/clinicUnpayDetail',
        name: 'clinicUnpayDetail',
        component: ClinicUnpayDetail,
        meta: {
            title: '缴费明细'
        }
    }, {
        path: '/examdetail',
        name: 'examdetail',
        component: ExamDetail,
        meta: {
            title: '检查报告'
        }
    }, {
        path: '/labdetail',
        name: 'labdetail',
        component: LabDetail,
        meta: {
            title: '检验报告'
        }
    }, {
        path: '/myreport',
        name: 'myreport',
        component: MyReport,
        meta: {
            title: '我的报告'
        }
    }, {
        path: '/hosinfo',
        name: 'hosinfo',
        component: HosInfo,
        meta: {
            title: '医院介绍'
        }
    }, {
        path: '/personal',
        name: 'personal',
        component: Personal,
        meta: {
            title: '个人信息'
        }
    }, {
        path: '/Profile',
        name: 'Profile',
        component: Profile,
        meta: {
            title: '个人中心'
        }
    }, {
        path: '/ModifyPhone',
        name: 'ModifyPhone',
        component: ModifyPhone,
        meta: {
            title: '修改手机号码'
        }
    }, {
        path: '/ConfirmPhone',
        name: 'ConfirmPhone',
        component: ConfirmPhone,
        meta: {
            title: '修改手机号码'
        }
    }, {
        path: '/Agreement',
        name: 'Agreement',
        component: Agreement,
        meta: {
            title: '用户协议'
        }
    }, {
        path: '/HospitalSelect',
        name: 'HospitalSelect',
        component: HospitalSelect,
        meta: {
            title: '选择医院'
        }
    }, {
        path: '/AreaSelect',
        name: 'AreaSelect',
        component: AreaSelect,
        meta: {
            title: '选择院区'
        }
    }, {
        path: '/DoctInfoList',
        name: 'DoctInfoList',
        component: DoctInfoList,
        meta: {
            title: '医生介绍'
        }
    }, {
        path: '/DoctInfo',
        name: 'DoctInfo',
        component: DoctInfo,
        meta: {
            title: '医生介绍'
        }
    }, {
        path: '/BedsInfo',
        name: 'BedsInfo',
        component: BedsInfo,
        meta: {
            title: '床位查询'
        }
    }, {
        path: '/VoucherSelect',
        name: 'VoucherSelect',
        component: VoucherSelect,
        meta: {
            title: '选择就诊人'
        }
    }, {
        path: '/RecordSelect',
        name: 'RecordSelect',
        component: RecordSelect,
        meta: {
            title: '选择档案项目'
        }
    }, {
        path: '/Character',
        name: 'Character',
        component: Character,
        meta: {
            title: '个人健康特征'
        }
    }, {
        path: '/residentHealthRecord',
        name: 'residentHealthRecord',
        component: residentHealthRecord,
        meta: {
            title: '居民健康档案'
        }
    }, {
        path: '/residentHealthRecordCode',
        name: 'residentHealthRecordCode',
        component: residentHealthRecordCode,
        meta: {
            title: '发送验证码'
        }
    }, {
        path: '/VisitRecord',
        name: 'VisitRecord',
        component: VisitRecord,
        meta: {
            title: '就诊记录'
        }
    }, {
        path: '/VisitRecordDetail',
        name: 'VisitRecordDetail',
        component: VisitRecordDetail,
        meta: {
            title: '就诊记录明细'
        }
    }, {
        path: '/PhysicalExam',
        name: 'PhysicalExam',
        component: PhysicalExam,
        meta: {
            title: '体检'
        }
    }, {
        path: '/PhysicalExamDetail',
        name: 'PhysicalExamDetail',
        component: PhysicalExamDetail,
        meta: {
            title: '体检报告详情'
        }
    }, {
        path: '/Developing',
        name: 'Developing',
        component: Developing,
        meta: {
            title: '功能正在开发'
        }
    }, {
        path: '/Maintaing',
        name: 'Maintaing',
        component: Maintaing,
        meta: {
            title: '功能正在建设'
        }
    }, {
        path: '/InpatientRecharge',
        name: 'InpatientRecharge',
        component: InpatientRecharge,
        meta: {
            title: '住院预缴金'
        }
    }, {
        path: '/MyRecharge',
        name: 'MyRecharge',
        component: MyRecharge,
        meta: {
            title: '预缴金充值记录'
        }
    }, {
        path: '/GoRecharge',
        name: 'GoRecharge',
        component: GoRecharge,
        meta: {
            title: '请输入充值金额'
        }
    }, {
        path: '/BookingResult',
        name: 'BookingResult',
        component: BookingResult,
        meta: {
            title: '预约结果'
        }
    }, {
        path: '/UnionPay',
        name: 'UnionPay',
        component: UnionPay,
        meta: {
            title: '银联支付'
        }
    }, {
        path: '/GetLocation',
        name: 'GetLocation',
        component : GetLocation,
        meta: {
            title: '获取当前位置'
        }
    }, {
        path: '/OutMap',
        name: 'OutMap',
        component: OutMap,
        meta: {
            title: '来院导航'
        }
    }, {
        path: '/InMap',
        name: 'InMap',
        component: InMap,
        meta: {
            title: '院内导航'
        }
    }, {
        path: '/Survey',
        name: 'Survey',
        component : Survey,
        meta: {
            title: '满意度调查'
        }
    }, {
        path: '/SurveyList',
        name: 'SurveyList',
        component: SurveyList,
        meta: {
            title: '问卷调查'
        }
    }, {
        path: '/SurveyDetail',
        name: 'SurveyDetail',
        component: SurveyDetail,
        meta: {
            title: '问卷调查详情'
        }
    }, {
       path: '/FamilyDoctor',
       name: 'FamilyDoctor',
       component : FamilyDoctor,
       meta: {
           title: '家庭医生签约'
        }
    },{
       path: '/Signed',
       name: 'Signed',
       component : Signed,
       meta: {
           title: '签约用户信息'
        }
    },{
        path: '/NoSigned',
        name: 'NoSigned',
        component : NoSigned,
        meta: {
            title: '签约申请',
            keepAlive: true
        }
    },{
        path: '/FamilyArgeeMent',
        name: 'FamilyArgeeMent',
        component : FamilyArgeeMent,
        meta: {
            title: '用户协议',
        }
    },{
        path: '/Review',
        name: 'Review',
        component : Review,
        meta: {
            title: '提交成功'
        }
    },{
        path: '/MyPrescription',
        name: 'MyPrescription',
        component : MyPrescription,
        meta: {
            title: '我的处方',
            keepAlive: true
        }
    },{
        path: '/PrescriptionDetail',
        name: 'PrescriptionDetail',
        component : PrescriptionDetail,
        meta: {
            title: '处方明细',
        }
    },{
        path: '/WaitDoctor',
        name: 'WaitDoctor',
        component : WaitDoctor,
        meta: {
            title: '排队候诊'
        }
    },{
        path: '/InpatientRegister',
        name: 'InpatientRegister',
        component : InpatientRegister,
        meta: {
            title: '住院登记'
        }
    },{
        path: '/InpatientDetails',
        name: 'InpatientDetails',
        component : InpatientDetails,
        meta: {
            title: '入院登记详情'
        }
    },{
        path: '/HospitalPage',
        name: 'HospitalPage',
        component : HospitalPage,
        meta: {
            title: '医院首页'
        }
    },{
        path: '/HealthySichuanRegister',
        name: 'HealthySichuanRegister',
        component : HealthySichuanRegister,
        meta: {
            title: '用户信息'
        }
    },{
        path: '/HealthySichuanMyRegister',
        name: 'HealthySichuanMyRegister',
        component : HealthySichuanMyRegister,
        meta: {
            title: '用户信息'
        }
    },{
        path: '/HospitalCostList',
        name: 'HospitalCostList',
        component : HospitalCostList,
        meta: {
            title: '住院费用查询'
        }
    },{
        path: '/HospitalCostListDetail',
        name: 'HospitalCostListDetail',
        component : HospitalCostListDetail,
        meta: {
            title: '住院费用明细'
        }
    },{
        path: '/registeredPrompt',
        name: 'registeredPrompt',
        component : registeredPrompt,
        meta: {
            title: '挂号须知'
        }
    },{
        path: '/internetHospital',
        name: 'internetHospital',
        component : internetHospital,
        meta: {
            title: '互联网医院'
        }
    },{
        path: '/littleAssistant',
        name: 'littleAssistant',
        component : littleAssistant,
        meta: {
            title: 'AI健康小助手'
        }
    }
];

const router = new Router({
    routes,
    mode: 'history'
})

router.afterEach(async (to) => {
    let baseLocation=location.origin
    if (window.__wxjs_is_wkwebview) { // IOS
        if (window.entryUrl == '' || window.entryUrl == undefined) {
            const url = baseLocation  + to.fullPath
            window.entryUrl = url
        }
    } else { // 安卓
        window.entryUrl = baseLocation + to.fullPath
    }


})

export default router



// WEBPACK FOOTER //
// ./src/router.js